import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Briefcase, GraduationCap, Building2, Rocket } from "lucide-react";
import { Button } from "@/components/ui/button";

const pathways = [
  {
    icon: Rocket,
    title: "Job Fast Track",
    subtitle: "Training programs for 3-6 month timelines",
    steps: ["PMKVY Training", "Certification", "Placement"],
    color: "border-l-primary",
    emoji: "🚀",
  },
  {
    icon: Briefcase,
    title: "Earn While Learn",
    subtitle: "₹5,000 - ₹9,000/month stipend",
    steps: ["NAPS Registration", "Apprenticeship", "Full-time Role"],
    color: "border-l-secondary",
    emoji: "💰",
  },
  {
    icon: Building2,
    title: "Government Career",
    subtitle: "Prepare for govt opportunities",
    steps: ["Skill India + SWAYAM", "Certifications", "Govt Job Prep"],
    color: "border-l-purple-500",
    emoji: "🏛️",
  },
  {
    icon: GraduationCap,
    title: "Skill & Freelance",
    subtitle: "Build skills, work independently",
    steps: ["Online Courses", "Portfolio Building", "Freelance / Startup"],
    color: "border-l-blue-500",
    emoji: "🎯",
  },
];

export const CareerPathwaysSection = () => {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Choose Your Career Path
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Not sure where to start? Pick a pathway that matches your goal — we'll help you explore options.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {pathways.map((path, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`group p-6 rounded-2xl bg-card border border-border ${path.color} border-l-4 hover:shadow-card transition-all duration-300`}
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="text-3xl">{path.emoji}</span>
                <div>
                  <h3 className="text-lg font-bold text-foreground">{path.title}</h3>
                  <p className="text-sm text-muted-foreground">{path.subtitle}</p>
                </div>
              </div>

              <div className="flex items-center gap-2 mb-4">
                {path.steps.map((step, i) => (
                  <div key={i} className="flex items-center">
                    <span className="text-xs bg-accent text-accent-foreground px-2 py-1 rounded-md font-medium">
                      {step}
                    </span>
                    {i < path.steps.length - 1 && (
                      <ArrowRight className="h-3 w-3 text-muted-foreground mx-1 flex-shrink-0" />
                    )}
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Button asChild variant="hero" size="xl">
            <Link to="/career-quiz">
              Find My Best Path
              <ArrowRight className="h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};
